/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner
 */
export interface GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    title?: string | null;
}

/**
 * Check if a given object implements the GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner interface.
 */
export function instanceOfGetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner(value: object): value is GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'title': json['title'] === undefined ? undefined : json['title'] === null ? null : json['title'],
    };
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner {
    return GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSONTyped(value?: GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'phone': value['phone'],
        'email': value['email'],
        'title': value['title'],
    };
}

